export default __webpack_public_path__ + "static/media/280c.89acb9bc.svg";